<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
  >
    <path
      d="M13.3861 0H15.9675L10.2885 6.38221L17 15H11.7636L7.63341 9.77163L2.95011 15H0.331887L6.41649 8.22115L0 0H5.38395L9.07158 4.79567L13.3861 0ZM12.4642 13.4856H13.9024L4.60954 1.44231H3.06074L12.4642 13.4856Z"
      fill="currentColor"
    />
  </svg>
</template>
